import { ODSColumn, ODSGrid } from '@telekom-ods/react-ui-kit';
import PropTypes from 'prop-types';
import { type ReactNode } from 'react';

import style from './SpecificationContent.module.css';

interface Logo {
  src: string;
  alt: string;
}

interface SpecificationContentProps {
  logo?: Logo;
  content: ReactNode;
}

const SpecificationContent = ({ logo, content }: SpecificationContentProps) => {
  return (
    <ODSColumn className={style.specification_container}>
      <ODSGrid
        container
        className={style.specification_grid ?? ''}
      >
        {logo?.src && (
          <ODSGrid columns={1}>
            <img
              className={style.product_logo}
              src={logo.src}
              alt={logo.alt}
            />
          </ODSGrid>
        )}
        <ODSGrid columns={logo?.src ? 12 : 14}>{content}</ODSGrid>
      </ODSGrid>
    </ODSColumn>
  );
};

SpecificationContent.propTypes = {
  logo: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
  }),
  content: PropTypes.node.isRequired,
};

export default SpecificationContent;
